<template>
    <InertiaHead>
        <link rel="icon" :href="favicon" type="image/x-icon" />
    </InertiaHead>
    <v-app id="app">
        <slot />
    </v-app>
</template>
<script setup lang="ts">
import favicon from '@shared/assets/images/favicon.ico';
</script>
